import React, { useRef } from "react";

import { Box } from "@mui/material";
import type { TextCardConfig } from "store/types";

interface Props {
  config: TextCardConfig;
  isPreview?: boolean;
  onChange?: (content: string) => void;
}

export const TextCard: React.FC<Props> = ({ config, isPreview, onChange }) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e.target.value);
    if (ref.current) {
      ref.current.style.height = "auto";
      ref.current.style.height = `${ref.current.scrollHeight}px`;
    }
  };

  if (isPreview) {
    return (
      <Box sx={{ p: "20px 24px", color: "#374151", fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-wrap" }}>
        {config.content}
      </Box>
    );
  }

  return (
    <Box sx={{ p: "12px 16px" }}>
      <Box
        component="textarea"
        ref={ref}
        value={config.content}
        onChange={handleChange}
        onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}
        placeholder="Type here..."
        sx={{
          width: "100%",
          minHeight: 80,
          border: "none",
          outline: "none",
          resize: "none",
          fontSize: 13,
          lineHeight: 1.7,
          color: "#374151",
          bgcolor: "transparent",
          fontFamily: "inherit",
          overflow: "hidden",
          boxSizing: "border-box"
        }}
      />
    </Box>
  );
};
